import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import Image from '~/components/Dynamic/Image';

export default function TestimonialAlt({ blok }) {
  return (
    <section className="my-20 bg-black md:my-32">
      <div className="container py-20 md:py-32">
        <div className="flex flex-col items-center max-w-3xl mx-auto font-extrabold text-center text-white uppercase">
          <div>
            <StaticImage src={`../assets/icons/sparks-blue-white.svg`} alt="sparks blue" />
          </div>
          <div>
            <h2 className="font-extrabold leading-tight uppercase text-26px md:text-52px font-heading ">
              {blok?.heading}
            </h2>
          </div>
          {blok?.icon && (
            <div className="mt-16">
              <Image blok={blok.icon} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
